import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import { YearType } from "./models-service";

const route_ns = `dicts/year`;

class YearService {
    private storageKey: string = 'year'
    data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);

    public cache_existence: any = {};

    current: YearType | null;
    YearList: YearType[] = [];

  constructor() {

    this.loadLocalStorageData();
    console.log('year service loaded');
    this.updateExistanceCache();
  }

  setCurrent(value: YearType) {
    this.current = value;
  }

  updateExistanceCache() {
    // читаем из кэша данные о существовании объекта
    let cache = localStorage.getItem('_existence');
    if(cache) {
      this.cache_existence = JSON.parse(cache);
    }
  }

  loadLocalStorageData() {

    let saved = localStorage.getItem(this.storageKey);
    if (saved) {
      try {

        this.YearList = JSON.parse(saved);
        this.YearList.sort((a:YearType, b:YearType) => a.name - b.name);
        this.setCurrent(this.YearList[this.YearList.length - 1]);
      } catch (e) {
        //
      }
    }


  }

  saveLocalStorageData(year: any) {
      if (year) {
      localStorage.setItem(this.storageKey, JSON.stringify(year));
    }
  }

  async updateFromDb() {
    // синхронизация с базой
    try {

      const yearData: any = await this.loadFromDb();

      if (yearData) {
        this.saveLocalStorageData(yearData.data);
        this.YearList = yearData.data;
        this.YearList.sort((a:YearType, b:YearType) => a.name - b.name);
      }
      console.log('year service loaded from db');
    } catch (e) {

      console.log(`${e}`);
    }

  }

  loadFromDb() {
    return request(`${route_ns}`, { method: "get" });
  }

  public async save(entity: YearType): Promise<IResponseResult<YearType>> {
    const response: AxiosResponse["data"] = await this.crud.save(entity);
    if (response) {
      return { data: response.data as YearType };
    } else {
      return { data: null, message: "" };
    }
  }

  /**
   * Возвращает список годов, которые используются (is_used === true)
   */
  get filteredYearList(): YearType[] {
    return this.YearList.filter((y: YearType) => y.is_used);
  }

  /**
   * Проверяет, можно ли удалить год (нет ли связанных срезок)
   * @param yearId ID года
   * @returns {Promise<string>} статус удаления
   */
  async checkDelete(yearId: string | number): Promise<string> {
    try {
      const response = await request(`${route_ns}/check_delete/${yearId}`, { method: 'get' });
      return typeof response.status === 'string' ? response.status : 'Exist_cuts';
    } catch (e) {
      return 'Exist_cuts'; // если ошибка, считаем что удалять нельзя
    }
  }

  /**
   * Удаляет год по ID
   * @param yearId ID года
   * @returns {Promise<boolean>} true если успешно, иначе false
   */
  async deleteYear(yearId: string | number): Promise<boolean> {
    try {
      await request(`${route_ns}/${yearId}`, { method: 'delete' });
      // После успешного удаления обновляем список годов
      await this.updateFromDb();
      return true;
    } catch (e) {
      return false;
    }
  }

  empty() {

  }

}

export default new YearService();
